export const pillarArticlesB = [
  {
    slug: 'cssbuy-spreadsheet-categories',
    image:
      'https://readdy.ai/api/search-image?query=A%20neat%20grid%20of%20colorful%20category%20tiles%20and%20folders%20representing%20shoes%20clothing%20bags%20and%20accessories%20on%20a%20soft%20light%20background%2C%20clean%20flat%20design%20illustration%20style%2C%20bright%20airy%20modern%20e-commerce%20concept%20with%20a%20fresh%20minimal%20aesthetic&width=600&height=400&seq=pillar-categories&orientation=landscape',
    title: {
      en: 'CSSBuy Spreadsheet Categories Explained',
      pt: 'Categorias do CSSBuy Spreadsheet Explicadas',
      de: 'CSSBuy Spreadsheet Kategorien erklärt',
    },
    summary: {
      en: 'An overview of every category in the CSSBuy Spreadsheet and what you can find in each.',
      pt: 'Uma visão geral de cada categoria no CSSBuy Spreadsheet e o que você pode encontrar em cada uma.',
      de: 'Ein Überblick über jede Kategorie im CSSBuy Spreadsheet und was Sie darin finden.',
    },
    intro: {
      en: 'The CSSBuy Spreadsheet is divided into clear categories that make it easy to find what you are looking for. From shoes and clothing to accessories and bags, each section has its own curated set of products and links. This guide walks through the main categories and what shoppers can expect to find in each.',
      pt: 'O CSSBuy Spreadsheet é dividido em categorias claras que facilitam encontrar o que você procura. De sapatos e roupas a acessórios e bolsas, cada seção tem seu próprio conjunto curado de produtos e links. Este guia percorre as principais categorias e o que os compradores podem esperar encontrar em cada uma.',
      de: 'Das CSSBuy Spreadsheet ist in klare Kategorien unterteilt, die es leicht machen, das Gesuchte zu finden. Von Schuhen und Kleidung bis zu Accessoires und Taschen hat jede Sektion ihr eigenes kuratiertes Set an Produkten und Links. Dieser Guide führt durch die Hauptkategorien und was Käufer in jeder erwarten können.',
    },
    sections: [
      {
        heading: {
          en: 'Shoes and Footwear',
          pt: 'Sapatos e calçados',
          de: 'Schuhe und Footwear',
        },
        body: {
          en: 'The shoe category is one of the most popular, with verified listings for sneakers and other footwear. Pay close attention to sizing notes and weight, as shoes often carry higher shipping costs.',
          pt: 'A categoria de sapatos é uma das mais populares, com listagens verificadas para tênis e outros calçados. Preste atenção às notas de tamanho e peso, pois sapatos geralmente têm custos de envio mais altos.',
          de: 'Die Schuh-Kategorie ist eine der beliebtesten, mit verifizierten Listings für Sneakers und anderes Schuhwerk. Achten Sie auf Größen- und Gewichtshinweise, da Schuhe oft höhere Versandkosten verursachen.',
        },
      },
      {
        heading: {
          en: 'Clothing and Apparel',
          pt: 'Roupas e vestuário',
          de: 'Kleidung und Bekleidung',
        },
        body: {
          en: 'Hoodies, t-shirts, jackets, and pants are grouped together with detailed fit guidance. Lightweight items are usually cheaper to ship than bulky outerwear.',
          pt: 'Moletons, camisetas, jaquetas e calças são agrupados com orientação detalhada de caimento. Itens leves geralmente são mais baratos de enviar do que agasalhos volumosos.',
          de: 'Hoodies, T-Shirts, Jacken und Hosen sind mit detaillierten Passformhinweisen gruppiert. Leichte Artikel sind in der Regel günstiger im Versand als sperrige Oberbekleidung.',
        },
      },
      {
        heading: {
          en: 'Accessories, Bags, and More',
          pt: 'Acessórios, bolsas e mais',
          de: 'Accessoires, Taschen und mehr',
        },
        body: {
          en: 'Accessories, bags, belts, and perfumes round out the catalog with smaller items that are easy to bundle. These are great for filling out an order without adding much weight.',
          pt: 'Acessórios, bolsas, cintos e perfumes completam o catálogo com itens menores fáceis de agrupar. Eles são ótimos para completar um pedido sem adicionar muito peso.',
          de: 'Accessoires, Taschen, Gürtel und Parfums runden den Katalog mit kleineren, leicht bündelbaren Artikeln ab. Sie eignen sich hervorragend, um eine Bestellung ohne viel Gewicht zu ergänzen.',
        },
      },
      {
        heading: {
          en: 'How to Browse Efficiently',
          pt: 'Como navegar com eficiência',
          de: 'Effizient durchsuchen',
        },
        body: {
          en: 'Start with the category closest to what you want, then narrow down by seller rating and weight. This focused approach saves time and leads to better purchases.',
          pt: 'Comece pela categoria mais próxima do que você deseja e depois refine por avaliação do vendedor e peso. Essa abordagem focada economiza tempo e leva a melhores compras.',
          de: 'Beginnen Sie mit der Kategorie, die Ihrem Wunsch am nächsten liegt, und grenzen Sie dann nach Verkäuferbewertung und Gewicht ein. Dieser fokussierte Ansatz spart Zeit und führt zu besseren Käufen.',
        },
      },
    ],
    faq: [
      {
        q: {
          en: 'Which category ships cheapest?',
          pt: 'Qual categoria é mais barata de enviar?',
          de: 'Welche Kategorie ist am günstigsten zu versenden?',
        },
        a: {
          en: 'Lightweight clothing like t-shirts and underwear generally has the lowest shipping costs.',
          pt: 'Roupas leves como camisetas e roupas íntimas geralmente têm os custos de envio mais baixos.',
          de: 'Leichte Kleidung wie T-Shirts und Unterwäsche hat in der Regel die niedrigsten Versandkosten.',
        },
      },
      {
        q: {
          en: 'Can I mix categories in one order?',
          pt: 'Posso misturar categorias em um pedido?',
          de: 'Kann ich Kategorien in einer Bestellung mischen?',
        },
        a: {
          en: 'Yes, combining items across categories is common and helps you bundle shipping more efficiently.',
          pt: 'Sim, combinar itens de várias categorias é comum e ajuda a agrupar o envio de forma mais eficiente.',
          de: 'Ja, das Kombinieren von Artikeln aus verschiedenen Kategorien ist üblich und hilft, den Versand effizienter zu bündeln.',
        },
      },
    ],
  },
  {
    slug: 'cssbuy-spreadsheet-shipping-guide',
    image:
      'https://readdy.ai/api/search-image?query=Stacked%20premium%20cardboard%20shipping%20boxes%20with%20packing%20tape%20and%20a%20measuring%20tape%20on%20a%20clean%20warm%20gray%20surface%2C%20soft%20studio%20lighting%2C%20professional%20logistics%20and%20e-commerce%20photography%20with%20a%20clean%20modern%20minimal%20aesthetic&width=600&height=400&seq=pillar-shipping&orientation=landscape',
    title: {
      en: 'CSSBuy Spreadsheet Shipping Guide',
      pt: 'Guia de Frete do CSSBuy Spreadsheet',
      de: 'CSSBuy Spreadsheet Versandguide',
    },
    summary: {
      en: 'How to estimate shipping costs, weight, and methods using the CSSBuy Spreadsheet.',
      pt: 'Como estimar custos de frete, peso e métodos usando o CSSBuy Spreadsheet.',
      de: 'So schätzen Sie Versandkosten, Gewicht und Methoden mit dem CSSBuy Spreadsheet.',
    },
    intro: {
      en: 'Shipping is often the most confusing part of buying through an agent, and the CSSBuy Spreadsheet helps take the guesswork out of it. By understanding weight, volume, and shipping methods, you can predict costs before you buy. This guide explains the shipping information included in the spreadsheet and how to use it.',
      pt: 'O frete costuma ser a parte mais confusa de comprar através de um agente, e o CSSBuy Spreadsheet ajuda a tirar as suposições da equação. Ao entender peso, volume e métodos de envio, você pode prever custos antes de comprar. Este guia explica as informações de frete incluídas na planilha e como usá-las.',
      de: 'Der Versand ist oft der verwirrendste Teil des Kaufs über einen Agenten, und das CSSBuy Spreadsheet hilft, das Rätselraten zu beenden. Wenn Sie Gewicht, Volumen und Versandmethoden verstehen, können Sie Kosten vor dem Kauf vorhersagen. Dieser Guide erklärt die Versandinformationen in der Tabelle und deren Nutzung.',
    },
    sections: [
      {
        heading: {
          en: 'Weight vs Volume',
          pt: 'Peso vs volume',
          de: 'Gewicht vs Volumen',
        },
        body: {
          en: 'Shipping costs are based on either actual weight or volumetric weight, whichever is higher. Bulky but light items can cost more than heavy but compact ones.',
          pt: 'Os custos de envio são baseados no peso real ou no peso volumétrico, o que for maior. Itens volumosos, mas leves, podem custar mais do que itens pesados, mas compactos.',
          de: 'Versandkosten basieren entweder auf dem tatsächlichen oder dem Volumengewicht, je nachdem, was höher ist. Sperrige, aber leichte Artikel können mehr kosten als schwere, aber kompakte.',
        },
      },
      {
        heading: {
          en: 'Shipping Methods',
          pt: 'Métodos de envio',
          de: 'Versandmethoden',
        },
        body: {
          en: 'The spreadsheet often lists recommended shipping lines with notes on speed and cost. Express lines are faster but pricier, while standard lines save money for non-urgent orders.',
          pt: 'A planilha frequentemente lista linhas de envio recomendadas com notas sobre velocidade e custo. Linhas expressas são mais rápidas, mas mais caras, enquanto linhas padrão economizam dinheiro para pedidos não urgentes.',
          de: 'Die Tabelle listet oft empfohlene Versandlinien mit Hinweisen zu Geschwindigkeit und Kosten. Express-Linien sind schneller, aber teurer, während Standard-Linien bei nicht dringenden Bestellungen Geld sparen.',
        },
      },
      {
        heading: {
          en: 'Estimating Your Cost',
          pt: 'Estimando seu custo',
          de: 'Ihre Kosten schätzen',
        },
        body: {
          en: 'Use the weight estimate in the spreadsheet to get a rough idea of shipping before you commit. Compare a few lines to find the best balance of cost and delivery time.',
          pt: 'Use a estimativa de peso na planilha para ter uma ideia aproximada do frete antes de se comprometer. Compare algumas linhas para encontrar o melhor equilíbrio entre custo e prazo de entrega.',
          de: 'Nutzen Sie die Gewichtsschätzung in der Tabelle, um vor dem Kauf eine grobe Vorstellung vom Versand zu bekommen. Vergleichen Sie einige Linien, um das beste Verhältnis von Kosten und Lieferzeit zu finden.',
        },
      },
      {
        heading: {
          en: 'Saving on Packaging',
          pt: 'Economizando na embalagem',
          de: 'Bei der Verpackung sparen',
        },
        body: {
          en: 'Removing shoe boxes or excess packaging reduces volume and can lower shipping costs. This simple step is often recommended in the spreadsheet for budget-conscious shoppers.',
          pt: 'Remover caixas de sapatos ou embalagens em excesso reduz o volume e pode diminuir os custos de envio. Esse passo simples é frequentemente recomendado na planilha para compradores econômicos.',
          de: 'Das Entfernen von Schuhkartons oder überflüssiger Verpackung reduziert das Volumen und kann die Versandkosten senken. Dieser einfache Schritt wird in der Tabelle oft für preisbewusste Käufer empfohlen.',
        },
      },
    ],
    faq: [
      {
        q: {
          en: 'What is the cheapest shipping method?',
          pt: 'Qual é o método de envio mais barato?',
          de: 'Was ist die günstigste Versandmethode?',
        },
        a: {
          en: 'Standard lines are usually cheapest but slower. The best choice depends on your destination and urgency.',
          pt: 'Linhas padrão geralmente são as mais baratas, porém mais lentas. A melhor escolha depende do seu destino e da urgência.',
          de: 'Standard-Linien sind meist am günstigsten, aber langsamer. Die beste Wahl hängt von Ihrem Ziel und der Dringlichkeit ab.',
        },
      },
      {
        q: {
          en: 'Does weight affect cost a lot?',
          pt: 'O peso afeta muito o custo?',
          de: 'Beeinflusst das Gewicht die Kosten stark?',
        },
        a: {
          en: 'Yes, both actual and volumetric weight directly influence shipping price, so lighter items are cheaper to ship.',
          pt: 'Sim, tanto o peso real quanto o volumétrico influenciam diretamente o preço do frete, então itens mais leves são mais baratos de enviar.',
          de: 'Ja, sowohl das tatsächliche als auch das Volumengewicht beeinflussen den Versandpreis direkt, sodass leichtere Artikel günstiger zu versenden sind.',
        },
      },
    ],
  },
  {
    slug: 'cssbuy-spreadsheet-qc-guide',
    image:
      'https://readdy.ai/api/search-image?query=A%20close-up%20of%20hands%20inspecting%20a%20premium%20sneaker%20with%20a%20magnifying%20glass%20on%20a%20bright%20clean%20inspection%20table%2C%20soft%20even%20lighting%2C%20professional%20quality%20control%20photography%20with%20a%20clean%20modern%20minimal%20aesthetic&width=600&height=400&seq=pillar-qc&orientation=landscape',
    title: {
      en: 'CSSBuy Spreadsheet QC Guide',
      pt: 'Guia de QC do CSSBuy Spreadsheet',
      de: 'CSSBuy Spreadsheet QC-Guide',
    },
    summary: {
      en: 'How to read quality check photos and verify items using the CSSBuy Spreadsheet.',
      pt: 'Como ler fotos de verificação de qualidade e verificar itens usando o CSSBuy Spreadsheet.',
      de: 'So lesen Sie Qualitätskontrollfotos und verifizieren Artikel mit dem CSSBuy Spreadsheet.',
    },
    intro: {
      en: 'Quality Check photos are your best defense against receiving the wrong or defective item. The CSSBuy Spreadsheet often includes QC references that show you what good photos should look like. This guide explains how to read QC photos and what to look for before approving shipment.',
      pt: 'As fotos de Quality Check são sua melhor defesa contra receber o item errado ou com defeito. O CSSBuy Spreadsheet frequentemente inclui referências de QC que mostram como devem ser as boas fotos. Este guia explica como ler as fotos de QC e o que procurar antes de aprovar o envio.',
      de: 'Quality-Check-Fotos sind Ihre beste Verteidigung gegen falsche oder defekte Artikel. Das CSSBuy Spreadsheet enthält oft QC-Referenzen, die zeigen, wie gute Fotos aussehen sollten. Dieser Guide erklärt, wie Sie QC-Fotos lesen und worauf Sie vor der Freigabe des Versands achten sollten.',
    },
    sections: [
      {
        heading: {
          en: 'What Are QC Photos?',
          pt: 'O que são fotos de QC?',
          de: 'Was sind QC-Fotos?',
        },
        body: {
          en: 'When your item arrives at the warehouse, staff photograph it from several angles before international shipping. These photos let you verify condition, color, and sizing before it leaves.',
          pt: 'Quando seu item chega ao armazém, a equipe o fotografa de vários ângulos antes do envio internacional. Essas fotos permitem verificar condição, cor e tamanho antes de ele partir.',
          de: 'Wenn Ihr Artikel im Lager ankommt, fotografiert das Personal ihn aus mehreren Winkeln vor dem internationalen Versand. Diese Fotos ermöglichen es Ihnen, Zustand, Farbe und Größe vor dem Versand zu prüfen.',
        },
      },
      {
        heading: {
          en: 'What to Check in Photos',
          pt: 'O que verificar nas fotos',
          de: 'Worauf Sie in Fotos achten sollten',
        },
        body: {
          en: 'Look for visible defects, color differences, and sizing labels. Compare the photo to the original product description to make sure they match.',
          pt: 'Procure defeitos visíveis, diferenças de cor e etiquetas de tamanho. Compare a foto com a descrição original do produto para garantir que correspondam.',
          de: 'Achten Sie auf sichtbare Mängel, Farbunterschiede und Größenetiketten. Vergleichen Sie das Foto mit der ursprünglichen Produktbeschreibung, um sicherzustellen, dass sie übereinstimmen.',
        },
      },
      {
        heading: {
          en: 'Common Defects to Spot',
          pt: 'Defeitos comuns a identificar',
          de: 'Häufige Mängel erkennen',
        },
        body: {
          en: 'Common issues include loose stitching, scuffs, glue marks, or wrong logos. The spreadsheet often highlights which defects to watch for in specific categories.',
          pt: 'Problemas comuns incluem costura solta, arranhões, marcas de cola ou logos errados. A planilha frequentemente destaca quais defeitos observar em categorias específicas.',
          de: 'Häufige Probleme sind lose Nähte, Kratzer, Kleberflecken oder falsche Logos. Die Tabelle hebt oft hervor, auf welche Mängel in bestimmten Kategorien zu achten ist.',
        },
      },
      {
        heading: {
          en: 'When to Request Changes',
          pt: 'Quando solicitar alterações',
          de: 'Wann Sie Änderungen anfordern sollten',
        },
        body: {
          en: 'If the photos reveal a problem, request a return or exchange while the item is still in the domestic warehouse. Acting early avoids costly international returns later.',
          pt: 'Se as fotos revelarem um problema, solicite uma devolução ou troca enquanto o item ainda está no armazém doméstico. Agir cedo evita devoluções internacionais caras depois.',
          de: 'Wenn die Fotos ein Problem zeigen, fordern Sie eine Rücksendung oder einen Umtausch an, solange der Artikel noch im Inlandslager ist. Frühzeitiges Handeln vermeidet spätere kostspielige internationale Rücksendungen.',
        },
      },
    ],
    faq: [
      {
        q: {
          en: 'Are QC photos always provided?',
          pt: 'As fotos de QC são sempre fornecidas?',
          de: 'Werden QC-Fotos immer bereitgestellt?',
        },
        a: {
          en: 'Most agents offer QC photos, but policies vary. Check the agent settings and request them if they are not automatic.',
          pt: 'A maioria dos agentes oferece fotos de QC, mas as políticas variam. Verifique as configurações do agente e solicite-as se não forem automáticas.',
          de: 'Die meisten Agenten bieten QC-Fotos an, aber die Richtlinien variieren. Prüfen Sie die Agenteneinstellungen und fordern Sie sie an, wenn sie nicht automatisch erfolgen.',
        },
      },
      {
        q: {
          en: 'What if I miss a defect?',
          pt: 'E se eu perder um defeito?',
          de: 'Was, wenn ich einen Mangel übersehe?',
        },
        a: {
          en: 'Take your time reviewing photos and zoom in on details. If you are unsure, ask for additional photos before approving.',
          pt: 'Reserve um tempo para revisar as fotos e dê zoom nos detalhes. Se não tiver certeza, peça fotos adicionais antes de aprovar.',
          de: 'Nehmen Sie sich Zeit beim Prüfen der Fotos und zoomen Sie in Details hinein. Wenn Sie unsicher sind, bitten Sie vor der Freigabe um weitere Fotos.',
        },
      },
    ],
  },
  {
    slug: 'cssbuy-spreadsheet-safety-guide',
    image:
      'https://readdy.ai/api/search-image?query=A%20sturdy%20padlock%20and%20a%20shield%20icon%20on%20a%20clean%20warm%20background%20with%20soft%20security%20themed%20lighting%2C%20trustworthy%20digital%20safety%20concept%20photography%20with%20a%20bright%20modern%20minimal%20aesthetic&width=600&height=400&seq=pillar-safety&orientation=landscape',
    title: {
      en: 'CSSBuy Spreadsheet Safety Guide',
      pt: 'Guia de Segurança do CSSBuy Spreadsheet',
      de: 'CSSBuy Spreadsheet Sicherheitsguide',
    },
    summary: {
      en: 'How to stay safe while shopping with the CSSBuy Spreadsheet, avoiding scams and fake links.',
      pt: 'Como se manter seguro ao comprar com o CSSBuy Spreadsheet, evitando golpes e links falsos.',
      de: 'So bleiben Sie beim Einkaufen mit dem CSSBuy Spreadsheet sicher und vermeiden Betrug und Fake-Links.',
    },
    intro: {
      en: 'Safety should always come first when shopping through an agent, and the CSSBuy Spreadsheet is built with safety in mind. From verifying links to recognizing fake coupons, a few simple habits can protect your money and account. This guide covers the key safety practices every shopper should follow.',
      pt: 'A segurança deve sempre vir em primeiro lugar ao comprar através de um agente, e o CSSBuy Spreadsheet foi criado com a segurança em mente. De verificar links a reconhecer cupons falsos, alguns hábitos simples podem proteger seu dinheiro e sua conta. Este guia cobre as principais práticas de segurança que todo comprador deve seguir.',
      de: 'Sicherheit sollte beim Einkaufen über einen Agenten immer an erster Stelle stehen, und das CSSBuy Spreadsheet wurde mit Sicherheit im Hinterkopf erstellt. Vom Verifizieren von Links bis zum Erkennen gefälschter Gutscheine können ein paar einfache Gewohnheiten Ihr Geld und Konto schützen. Dieser Guide behandelt die wichtigsten Sicherheitspraktiken.',
    },
    sections: [
      {
        heading: {
          en: 'Verify Links Before Clicking',
          pt: 'Verifique os links antes de clicar',
          de: 'Links vor dem Klicken prüfen',
        },
        body: {
          en: 'Always check that a link points to a legitimate marketplace domain. Misspelled or suspicious URLs are a common sign of phishing.',
          pt: 'Sempre verifique se um link aponta para um domínio de marketplace legítimo. URLs com erros de digitação ou suspeitas são um sinal comum de phishing.',
          de: 'Prüfen Sie immer, ob ein Link auf eine legitime Marktplatz-Domain zeigt. Falsch geschriebene oder verdächtige URLs sind ein häufiges Anzeichen für Phishing.',
        },
      },
      {
        heading: {
          en: 'Avoid Fake Coupons',
          pt: 'Evite cupons falsos',
          de: 'Gefälschte Gutscheine vermeiden',
        },
        body: {
          en: 'Be wary of coupons from unknown sources promising huge discounts. Only use codes shared through trusted channels or listed in the spreadsheet.',
          pt: 'Desconfie de cupons de fontes desconhecidas que prometem grandes descontos. Use apenas códigos compartilhados por canais confiáveis ou listados na planilha.',
          de: 'Seien Sie vorsichtig bei Gutscheinen aus unbekannten Quellen, die große Rabatte versprechen. Verwenden Sie nur Codes aus vertrauenswürdigen Kanälen oder aus der Tabelle.',
        },
      },
      {
        heading: {
          en: 'Secure Your Account',
          pt: 'Proteja sua conta',
          de: 'Ihr Konto sichern',
        },
        body: {
          en: 'Use a strong unique password and enable two-factor authentication on your agent account. Never share your login details with anyone.',
          pt: 'Use uma senha forte e exclusiva e ative a autenticação de dois fatores na sua conta do agente. Nunca compartilhe seus dados de login com ninguém.',
          de: 'Verwenden Sie ein starkes, einzigartiges Passwort und aktivieren Sie die Zwei-Faktor-Authentifizierung für Ihr Agentenkonto. Geben Sie Ihre Zugangsdaten niemals weiter.',
        },
      },
      {
        heading: {
          en: 'Pay Through the Agent',
          pt: 'Pague através do agente',
          de: 'Über den Agenten bezahlen',
        },
        body: {
          en: 'Always complete payments inside the agent platform rather than sending money directly to sellers. Direct payment offers little protection if something goes wrong.',
          pt: 'Sempre conclua os pagamentos dentro da plataforma do agente em vez de enviar dinheiro diretamente aos vendedores. Pagamentos diretos oferecem pouca proteção se algo der errado.',
          de: 'Schließen Sie Zahlungen immer innerhalb der Agentenplattform ab, statt Geld direkt an Verkäufer zu senden. Direktzahlungen bieten wenig Schutz, wenn etwas schiefgeht.',
        },
      },
    ],
    faq: [
      {
        q: {
          en: 'What if I clicked a fake link?',
          pt: 'E se eu clicar em um link falso?',
          de: 'Was, wenn ich auf einen Fake-Link geklickt habe?',
        },
        a: {
          en: 'Close the page immediately and do not enter any login or payment details. Report the link to the community.',
          pt: 'Feche a página imediatamente e não insira nenhum dado de login ou pagamento. Reporte o link à comunidade.',
          de: 'Schließen Sie die Seite sofort und geben Sie keine Anmelde- oder Zahlungsdaten ein. Melden Sie den Link der Community.',
        },
      },
      {
        q: {
          en: 'How do I know a seller is safe?',
          pt: 'Como saber se um vendedor é seguro?',
          de: 'Woher weiß ich, dass ein Verkäufer sicher ist?',
        },
        a: {
          en: 'Look for consistent positive ratings and buyer feedback in the spreadsheet, and always verify the live listing.',
          pt: 'Procure avaliações positivas consistentes e feedback de compradores na planilha, e sempre verifique a listagem ao vivo.',
          de: 'Achten Sie auf durchweg positive Bewertungen und Käuferfeedback in der Tabelle und verifizieren Sie immer das Live-Listing.',
        },
      },
    ],
  },
  {
    slug: 'cssbuy-spreadsheet-faq',
    image:
      'https://readdy.ai/api/search-image?query=A%20clean%20modern%20help%20desk%20concept%20with%20a%20large%20question%20mark%20and%20speech%20bubbles%20on%20a%20soft%20light%20background%2C%20bright%20friendly%20illustration%20style%2C%20approachable%20customer%20support%20design%20with%20a%20fresh%20minimal%20aesthetic&width=600&height=400&seq=pillar-faq&orientation=landscape',
    title: {
      en: 'CSSBuy Spreadsheet FAQ',
      pt: 'FAQ do CSSBuy Spreadsheet',
      de: 'CSSBuy Spreadsheet FAQ',
    },
    summary: {
      en: 'Answers to the most common questions about the CSSBuy Spreadsheet.',
      pt: 'Respostas para as perguntas mais comuns sobre o CSSBuy Spreadsheet.',
      de: 'Antworten auf die häufigsten Fragen zum CSSBuy Spreadsheet.',
    },
    intro: {
      en: 'New shoppers often have the same questions when they first discover the CSSBuy Spreadsheet. This FAQ collects the most common ones in one place so you can get up to speed quickly. From what the spreadsheet is to how to stay safe, we have you covered.',
      pt: 'Novos compradores costumam ter as mesmas perguntas quando descobrem o CSSBuy Spreadsheet pela primeira vez. Esta FAQ reúne as mais comuns em um só lugar para que você possa se atualizar rapidamente. Do que é a planilha a como se manter seguro, temos tudo coberto.',
      de: 'Neue Käufer haben oft dieselben Fragen, wenn sie das CSSBuy Spreadsheet zum ersten Mal entdecken. Diese FAQ bündelt die häufigsten an einem Ort, damit Sie schnell auf den neuesten Stand kommen. Von der Frage, was die Tabelle ist, bis hin zur Sicherheit sind Sie abgedeckt.',
    },
    sections: [
      {
        heading: {
          en: 'What Is the Spreadsheet?',
          pt: 'O que é a planilha?',
          de: 'Was ist die Tabelle?',
        },
        body: {
          en: 'It is a curated collection of product links, seller information, and buying resources for shoppers who use CSSBuy. It centralizes research so you can buy with confidence.',
          pt: 'É uma coleção curada de links de produtos, informações de vendedores e recursos de compra para compradores que usam a CSSBuy. Ela centraliza a pesquisa para que você possa comprar com confiança.',
          de: 'Es ist eine kuratierte Sammlung von Produktlinks, Verkäuferinformationen und Kaufressourcen für Käufer, die CSSBuy nutzen. Sie bündelt die Recherche, damit Sie sicher einkaufen können.',
        },
      },
      {
        heading: {
          en: 'Is It Free?',
          pt: 'É gratuito?',
          de: 'Ist es kostenlos?',
        },
        body: {
          en: 'Yes, the spreadsheet is freely shared within the community. Our resource hub provides free guides and curated lists to help shoppers make informed choices.',
          pt: 'Sim, a planilha é compartilhada gratuitamente dentro da comunidade. Nosso hub de recursos fornece guias e listas curadas gratuitamente para ajudar os compradores a fazer escolhas informadas.',
          de: 'Ja, die Tabelle wird innerhalb der Community kostenlos geteilt. Unser Ressourcen-Hub bietet kostenlose Guides und kuratierte Listen, um Käufern fundierte Entscheidungen zu ermöglichen.',
        },
      },
      {
        heading: {
          en: 'How Do I Get Started?',
          pt: 'Como começo?',
          de: 'Wie fange ich an?',
        },
        body: {
          en: 'Open the current version, choose a category, and browse verified products. Verify the live link and check QC photos before placing any order.',
          pt: 'Abra a versão atual, escolha uma categoria e navegue pelos produtos verificados. Verifique o link ao vivo e as fotos de QC antes de fazer qualquer pedido.',
          de: 'Öffnen Sie die aktuelle Version, wählen Sie eine Kategorie und durchsuchen Sie verifizierte Produkte. Prüfen Sie den Live-Link und die QC-Fotos, bevor Sie eine Bestellung aufgeben.',
        },
      },
      {
        heading: {
          en: 'Where Can I Learn More?',
          pt: 'Onde posso aprender mais?',
          de: 'Wo kann ich mehr erfahren?',
        },
        body: {
          en: 'Explore our other guides on products, sellers, shipping, QC, and safety. Each dives deeper into a specific part of the shopping experience.',
          pt: 'Explore nossos outros guias sobre produtos, vendedores, frete, QC e segurança. Cada um aprofunda uma parte específica da experiência de compra.',
          de: 'Entdecken Sie unsere anderen Guides zu Produkten, Verkäufern, Versand, QC und Sicherheit. Jeder geht tiefer auf einen bestimmten Teil des Einkaufserlebnisses ein.',
        },
      },
    ],
    faq: [
      {
        q: {
          en: 'Do I need experience to use it?',
          pt: 'Preciso de experiência para usar?',
          de: 'Brauche ich Erfahrung, um es zu nutzen?',
        },
        a: {
          en: 'No, the spreadsheet is beginner-friendly with clear labels and guidance for new shoppers.',
          pt: 'Não, a planilha é amigável para iniciantes, com rótulos claros e orientação para novos compradores.',
          de: 'Nein, die Tabelle ist einsteigerfreundlich mit klaren Beschriftungen und Anleitungen für neue Käufer.',
        },
      },
      {
        q: {
          en: 'Where should I start my research?',
          pt: 'Por onde devo começar minha pesquisa?',
          de: 'Wo sollte ich mit meiner Recherche beginnen?',
        },
        a: {
          en: 'Begin with the main CSSBuy Spreadsheet guide, then explore topics like sellers and shipping as you need them.',
          pt: 'Comece com o guia principal do CSSBuy Spreadsheet e depois explore tópicos como vendedores e frete conforme precisar.',
          de: 'Beginnen Sie mit dem Haupt-CSSBuy-Spreadsheet-Guide und erkunden Sie dann Themen wie Verkäufer und Versand nach Bedarf.',
        },
      },
    ],
  },
];